import { render } from "./identifiant.vue?vue&type=template&id=bbdd8e4a&scoped=true"
import script from "./identifiant.vue?vue&type=script&lang=js"
export * from "./identifiant.vue?vue&type=script&lang=js"

import "./identifiant.vue?vue&type=style&index=0&id=bbdd8e4a&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbdd8e4a"]])

export default __exports__